import React from "react";
import * as ReactDOM from "react-dom/client";
import "./landing-shared.entry.jsx";
const SiteNav = globalThis.SiteNav ?? globalThis.window?.SiteNav;
const SiteFooter = globalThis.SiteFooter ?? globalThis.window?.SiteFooter;
// API & MCP page
const { useState } = React;

const Arrow = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path d="M3 6h6m0 0L6 3m3 3L6 9" stroke="currentColor" strokeWidth="1.4" strokeLinecap="square"/>
  </svg>
);

function HeroExample() {
  const tabs = ['curl', 'mcp.json', 'python', 'node'];
  const [t, setT] = useState(0);
  const samples = [
    <pre key="c" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
      <span className="com"># Hosted MCP protected-resource metadata</span>{'\n'}
      <span className="kw">curl</span> https://mcp.named.network/.well-known/oauth-protected-resource/mcp{'\n'}
      {'\n'}
      <span className="com"># &rarr; 200 OK</span>{'\n'}
      <span className="punct">{`{`}</span>{'\n'}
      {'  '}<span className="key">"resource"</span><span className="punct">:</span> <span className="str">"https://mcp.named.network/mcp"</span><span className="punct">,</span>{'\n'}
      {'  '}<span className="key">"authorization_servers"</span><span className="punct">:</span> <span className="punct">[</span><span className="str">"https://api.named.network"</span><span className="punct">]</span>{'\n'}
      <span className="punct">{`}`}</span>
    </pre>,
    <pre key="m" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
      <span className="com"># Hosted MCP client config</span>{'\n'}
      <span className="punct">{`{`}</span>{'\n'}
      {'  '}<span className="key">"mcpServers"</span><span className="punct">:</span> <span className="punct">{`{`}</span>{'\n'}
      {'    '}<span className="key">"named-network"</span><span className="punct">:</span> <span className="punct">{`{`}</span>{'\n'}
      {'      '}<span className="key">"url"</span><span className="punct">:</span> <span className="str">"https://mcp.named.network/mcp"</span><span className="punct">,</span>{'\n'}
      {'      '}<span className="key">"headers"</span><span className="punct">:</span> <span className="punct">{`{`}</span>{'\n'}
      {'        '}<span className="key">"Authorization"</span><span className="punct">:</span> <span className="str">"Bearer named_live_•••••"</span>{'\n'}
      {'      '}<span className="punct">{`}`}</span>{'\n'}
      {'    '}<span className="punct">{`}`}</span>{'\n'}
      {'  '}<span className="punct">{`}`}</span>{'\n'}
      <span className="punct">{`}`}</span>
    </pre>,
    <pre key="p" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
      <span className="kw">import</span> requests{'\n'}
      {'\n'}
      payload <span className="punct">=</span> <span className="punct">{`{`}</span>{'\n'}
      {'    '}<span className="str">"jsonrpc"</span><span className="punct">:</span> <span className="str">"2.0"</span><span className="punct">,</span>{'\n'}
      {'    '}<span className="str">"id"</span><span className="punct">:</span> <span className="num">1</span><span className="punct">,</span>{'\n'}
      {'    '}<span className="str">"method"</span><span className="punct">:</span> <span className="str">"tools/call"</span><span className="punct">,</span>{'\n'}
      {'    '}<span className="str">"params"</span><span className="punct">:</span> <span className="punct">{`{`}</span><span className="str">"name"</span><span className="punct">:</span> <span className="str">"private_network.health"</span><span className="punct">{`}`}</span>{'\n'}
      <span className="punct">{`}`}</span>{'\n'}
      {'\n'}
      resp <span className="punct">=</span> requests<span className="punct">.</span>post<span className="punct">(</span>{'\n'}
      {'    '}<span className="str">"https://mcp.named.network/mcp"</span><span className="punct">,</span>{'\n'}
      {'    '}headers<span className="punct">=</span><span className="punct">{`{`}</span><span className="str">"Authorization"</span><span className="punct">:</span> <span className="str">"Bearer named_live_•••••"</span><span className="punct">{`}`}</span><span className="punct">,</span>{'\n'}
      {'    '}json<span className="punct">=</span>payload<span className="punct">,</span>{'\n'}
      <span className="punct">)</span>
    </pre>,
    <pre key="n" style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
      <span className="kw">const</span> payload <span className="punct">=</span> <span className="punct">{`{`}</span>{'\n'}
      {'  '}jsonrpc<span className="punct">:</span> <span className="str">"2.0"</span><span className="punct">,</span>{'\n'}
      {'  '}id<span className="punct">:</span> <span className="num">1</span><span className="punct">,</span>{'\n'}
      {'  '}method<span className="punct">:</span> <span className="str">"tools/list"</span>{'\n'}
      <span className="punct">{`}`}</span><span className="punct">;</span>{'\n'}
      {'\n'}
      <span className="kw">const</span> res <span className="punct">=</span> <span className="kw">await</span> fetch<span className="punct">(</span><span className="str">"https://mcp.named.network/mcp"</span><span className="punct">,</span> <span className="punct">{`{`}</span>{'\n'}
      {'  '}method<span className="punct">:</span> <span className="str">"POST"</span><span className="punct">,</span>{'\n'}
      {'  '}headers<span className="punct">:</span> <span className="punct">{`{`}</span>{'\n'}
      {'    '}<span className="str">"Content-Type"</span><span className="punct">:</span> <span className="str">"application/json"</span><span className="punct">,</span>{'\n'}
      {'    '}<span className="str">"Authorization"</span><span className="punct">:</span> <span className="str">"Bearer named_live_•••••"</span>{'\n'}
      {'  '}<span className="punct">{`}`}</span><span className="punct">,</span>{'\n'}
      {'  '}body<span className="punct">:</span> JSON<span className="punct">.</span>stringify<span className="punct">(</span>payload<span className="punct">)</span>{'\n'}
      <span className="punct">{`}`}</span><span className="punct">)</span><span className="punct">;</span>
    </pre>,
  ];
  return (
    <div className="code-win">
      <div className="api-tabs">
        {tabs.map((tab, i) => (
          <button key={i} className={`api-tab ${t === i ? 'on' : ''}`} onClick={() => setT(i)}>{tab}</button>
        ))}
      </div>
      <div className="cw-body">{samples[t]}</div>
    </div>
  );
}

function Hero() {
  return (
    <section className="section section-dark api-hero">
      <div className="dark-grid"></div>
      <div className="dark-glow"></div>
      <div className="container">
        <span className="api-eyebrow"><span className="eb-dot"></span>API · MCP · WEBHOOKS</span>
        <h1>Build against<br/>the control plane.<br/><em>Hosted MCP first, API contracts second.</em></h1>
        <p className="lead">named.network already exposes a real hosted MCP surface for Business workflows, plus the underlying control-plane API contracts the dashboard uses for apps, devices, setup tokens, DNS, network diagnostics, and bounded egress. This page is about the product we actually have today, not a fantasy public developer program.</p>

        <div className="api-hero-bottom">
          <HeroExample />
          <div className="api-stats">
            <div className="api-stat"><div className="big"><em>v1</em> alpha</div><div className="lbl">Current control-plane contract in repo</div></div>
            <div className="api-stat"><div className="big"><em>8</em> hosted scopes</div><div className="lbl">Default-deny, approval-aware where needed</div></div>
            <div className="api-stat"><div className="big"><em>2</em> transport stories</div><div className="lbl">Hosted MCP for remote workflows · local stdio for same-machine work</div></div>
            <div className="api-stat"><div className="big"><em>~38ms</em></div><div className="lbl">Example hosted round-trip in the demo view</div></div>
          </div>
        </div>

        <div style={{ marginTop: 56, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
          <a href="https://app.named.network/signup" className="btn btn-accent btn-lg"><span>Create a Business workspace <Arrow /></span></a>
          <a href="#mcp" className="btn btn-on-dark btn-lg"><span>MCP details</span></a>
          <a href="/docs" className="btn btn-on-dark btn-lg"><span>Current docs</span></a>
        </div>
      </div>
    </section>
  );
}

function Protocols() {
  return (
    <section className="protocols">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">Two protocols, one mental model</span>
          <h2>Pick the one that fits the workflow.</h2>
          <p>The current product is strongest on hosted MCP for remote agent workflows and on the underlying control-plane API contracts used by the dashboard. They are related surfaces, but they do not share one flattened auth or approval model.</p>
        </div>
        <div className="proto-grid">
          <div className="proto">
            <div className="ptag">01 · REST · OPENAPI 3.1</div>
            <h3>For control-plane integrations and operator tooling.</h3>
            <p>The dashboard already runs against a versioned JSON control-plane API. That contract is real and useful, but it is still best described as the current product API surface rather than a fully polished public developer platform.</p>
            <ul>
              <li>Versioned <code>/v1</code> control-plane paths</li>
              <li>Real resource families for apps, devices, setup, DNS, network, and Business tokens</li>
              <li>Session-authenticated dashboard flows plus specific tokenized Business surfaces</li>
              <li>The current alpha contract already exists in the repo and matches what the dashboard is using</li>
            </ul>
            <a href="/docs" className="btn btn-on-light"><span>See current docs <Arrow /></span></a>
          </div>
          <div className="proto">
            <div className="ptag">02 · MCP · JSON-RPC 2.0</div>
            <h3>For Claude, Cursor, Codex, OpenAI, and Anthropic workflows.</h3>
            <p>A first-class hosted MCP server for remote tool use, plus a local <code>namedn mcp serve</code> bridge for same-machine IDE flows. The current claim should stay tools-first and approval-aware instead of implying a broader prompt/resource platform than we ship today.</p>
            <ul>
              <li>Hosted endpoint at <code>https://mcp.named.network/mcp</code></li>
              <li>Local <code>stdio</code> bridge via <code>namedn mcp serve</code></li>
              <li>Tools-first hosted surface with narrow MCP scope families</li>
              <li>Approval-aware mutations for risky actions</li>
              <li>Hosted OAuth and Business-token flows stay separate from local workstation auth</li>
            </ul>
            <a href="/ai" className="btn btn-on-light"><span>See AI &amp; Automation <Arrow /></span></a>
          </div>
        </div>
      </div>
    </section>
  );
}

function MCPSection() {
  const tools = [
    { n: 'devices.list', d: 'List enrolled devices safely. scope: mcp:devices:read' },
    { n: 'private_apps.list', d: 'List protected apps and current status. scope: mcp:private_apps:read' },
    { n: 'private_apps.create', d: 'Create a protected app through the hosted tool surface. scope: mcp:private_apps:write' },
    { n: 'setup_tokens.create', d: 'Mint a setup token with approval-aware mutation flow. scope: mcp:setup_tokens:write' },
    { n: 'private_network.health', d: 'Read network health and diagnostics. scope: mcp:private_network:read' },
    { n: 'secure_dns.summary', d: 'Inspect Secure DNS summary state. scope: mcp:secure_dns:read' },
    { n: 'egress.session.create', d: 'Mint a bounded public-web task handle. scope: mcp:egress:write' },
    { n: 'network_actions.execute', d: 'Execute an approved network-action handle. scope: mcp:egress:write' },
  ];
  return (
    <section className="mcp" id="mcp">
      <div className="dark-grid"></div>
      <div className="container">
        <div className="section-h">
          <span className="section-label">MCP &mdash; Model Context Protocol</span>
          <h2 style={{ color: 'var(--text-dark-primary)' }}>What the hosted MCP surface actually means here.</h2>
          <p>The same control-plane primitives already used by the dashboard &mdash; apps, devices, setup, Secure DNS, private-network diagnostics, and bounded egress &mdash; mapped onto a hosted MCP tool surface. The current public claim should stay tools-first and approval-aware.</p>
        </div>
        <div className="mcp-grid">
          <div className="mcp-copy">
            <h3>Tools</h3>
            <p>Hosted MCP tools are grouped into narrow scope families. If your token only has <code>mcp:private_apps:read</code>, read-only protected-app tools are visible; write tools and network-action tools stay out of reach.</p>
            <p>Hosted tool calls are scoped, audited, and approval-aware where the action changes live state. Local <code>stdio</code> follows the same approval pattern, but not the same OAuth or token model.</p>
            <div className="mcp-tools">
              {tools.map((t, i) => (
                <div key={i} className="mcp-tool">
                  <div className="tn">{t.n}</div>
                  <div className="td">{t.d}</div>
                </div>
              ))}
            </div>
          </div>
          <div>
            <div className="code-win">
              <div className="cw-head">
                <span>MCP CALL · scoped, audited, denied where it should be</span>
                <span className="dots"><span></span><span></span><span></span></span>
              </div>
              <div className="cw-body">
                <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                  <span className="com">// initialize</span>{'\n'}
                  <span className="punct">→</span> <span className="punct">{`{`}</span> <span className="key">"method"</span><span className="punct">:</span> <span className="str">"initialize"</span><span className="punct">,</span> <span className="key">"params"</span><span className="punct">:</span> <span className="punct">{`{`}</span> <span className="key">"clientInfo"</span><span className="punct">:</span> <span className="punct">{`{`}</span> <span className="key">"name"</span><span className="punct">:</span> <span className="str">"claude-desktop"</span> <span className="punct">{`}`}</span> <span className="punct">{`}`}</span> <span className="punct">{`}`}</span>{'\n'}
                  <span className="punct">←</span> <span className="punct">{`{`}</span> <span className="key">"serverInfo"</span><span className="punct">:</span> <span className="punct">{`{`}</span> <span className="key">"name"</span><span className="punct">:</span> <span className="str">"named-network-mcp/v1"</span> <span className="punct">{`}`}</span> <span className="punct">{`}`}</span>{'\n'}
                  {'\n'}
                  <span className="com">// tools/list — only tools your scopes cover</span>{'\n'}
                  <span className="punct">→</span> <span className="punct">{`{`}</span> <span className="key">"method"</span><span className="punct">:</span> <span className="str">"tools/list"</span> <span className="punct">{`}`}</span>{'\n'}
                  <span className="punct">←</span> <span className="punct">{`{`}</span> <span className="key">"tools"</span><span className="punct">:</span> <span className="punct">[</span><span className="str">"private_apps.list"</span><span className="punct">,</span> <span className="str">"private_network.health"</span><span className="punct">]</span> <span className="punct">{`}`}</span>{'\n'}
                  {'\n'}
                  <span className="com">// allowed call</span>{'\n'}
                  <span className="punct">→</span> <span className="punct">{`{`}</span> <span className="key">"method"</span><span className="punct">:</span> <span className="str">"tools/call"</span><span className="punct">,</span> <span className="key">"params"</span><span className="punct">:</span> <span className="punct">{`{`}</span> <span className="key">"name"</span><span className="punct">:</span> <span className="str">"private_network.health"</span> <span className="punct">{`}`}</span> <span className="punct">{`}`}</span>{'\n'}
                  <span className="punct">←</span> <span className="punct">{`{`}</span> <span className="key">"content"</span><span className="punct">:</span> <span className="punct">[...]</span> <span className="punct">{`}`}</span>{'\n'}
                  {'\n'}
                  <span className="com">// mutation preview &mdash; approval required before live change</span>{'\n'}
                  <span className="punct">→</span> <span className="punct">{`{`}</span> <span className="key">"method"</span><span className="punct">:</span> <span className="str">"tools/call"</span><span className="punct">,</span> <span className="key">"params"</span><span className="punct">:</span> <span className="punct">{`{`}</span> <span className="key">"name"</span><span className="punct">:</span> <span className="str">"setup_tokens.create"</span> <span className="punct">{`}`}</span> <span className="punct">{`}`}</span>{'\n'}
                  <span className="punct">←</span> <span className="punct">{`{`}</span> <span className="key">"status"</span><span className="punct">:</span> <span className="str">"approval_required"</span><span className="punct">,</span> <span className="key">"approvalToken"</span><span className="punct">:</span> <span className="str">"apr_•••••"</span> <span className="punct">{`}`}</span>
                </pre>
              </div>
            </div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-dark-muted)', marginTop: 14, letterSpacing: '0.04em' }}>
              Hosted tool calls emit audit events, and risky mutations can return <code style={{ color: 'var(--accent)' }}>approval_required</code> before live state changes.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Endpoints() {
  const groups = ['Private Apps', 'Devices', 'Setup', 'DNS', 'Network', 'Business tokens'];
  const [g, setG] = useState(0);
  const all = {
    "Private Apps": [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/private-apps', d: 'List protected apps in the workspace', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/private-apps', d: 'Register a new local app for protection', s: 'session / workspace auth' },
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/private-apps/{appId}', d: 'Read one protected app and current state', s: 'session / workspace auth' },
      { v: 'PATCH', vc: 'put', p: '/v1/workspaces/{workspaceId}/private-apps/{appId}', d: 'Update protected-app settings', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/private-apps/{appId}/disable', d: 'Disable a protected app', s: 'session / workspace auth' },
    ],
    Devices: [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/devices', d: 'List enrolled agents and their state', s: 'session / workspace auth' },
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/devices/{deviceId}', d: 'Read one agent: OS, version, last seen', s: 'session / workspace auth' },
      { v: 'PATCH', vc: 'put', p: '/v1/workspaces/{workspaceId}/devices/{deviceId}', d: 'Update device settings and labels', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/devices/{deviceId}/disable', d: 'Disable a device from the workspace', s: 'session / workspace auth' },
    ],
    Setup: [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/setup-tokens', d: 'List current setup tokens / install commands', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/setup-tokens', d: 'Create a setup token or install command', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/setup-tokens/{tokenId}/revoke', d: 'Revoke an unused setup token', s: 'session / workspace auth' },
    ],
    DNS: [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/dns/profiles', d: 'List Secure DNS profiles', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/dns/profiles', d: 'Create a Secure DNS profile', s: 'session / workspace auth' },
      { v: 'PATCH', vc: 'put', p: '/v1/workspaces/{workspaceId}/dns/profiles/{profileId}', d: 'Update one DNS profile', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/dns/profiles/{profileId}/rules', d: 'Add allow or block rules', s: 'session / workspace auth' },
      { v: 'DELETE', vc: 'del', p: '/v1/workspaces/{workspaceId}/dns/rules/{ruleId}', d: 'Delete one DNS rule', s: 'session / workspace auth' },
    ],
    Network: [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/private-network', d: 'Read the private-network summary', s: 'session / workspace auth' },
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/private-network/health', d: 'Read alert-friendly health and diagnostic windows', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/devices/{deviceId}/routes', d: 'Request or create a route', s: 'session / workspace auth' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/devices/{deviceId}/network-settings', d: 'Update private-network device settings', s: 'session / workspace auth' },
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/gateway-sessions', d: 'Read bounded public-gateway sessions', s: 'session / workspace auth' },
    ],
    "Business tokens": [
      { v: 'GET', vc: 'get', p: '/v1/workspaces/{workspaceId}/api-tokens', d: 'List Business API tokens (no raw secrets)', s: 'Business owner/admin' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/api-tokens', d: 'Create a scoped Business token &mdash; reveal once', s: 'Business owner/admin' },
      { v: 'POST', vc: 'post', p: '/v1/workspaces/{workspaceId}/api-tokens/{tokenId}/revoke', d: 'Revoke a Business token', s: 'Business owner/admin' },
    ],
  };
  const rows = all[groups[g]];
  return (
    <section className="endpoints" id="openapi">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">Current control-plane families</span>
          <h2>The current contract we can actually stand behind.</h2>
          <p>These are the resource families already present in the repo and used by the dashboard today. They are real, but they should still be described as the current control-plane contract rather than a fully productized self-serve public developer catalog.</p>
        </div>
        <div className="ep-tabs">
          {groups.map((name, i) => (
            <button key={name} className={`ep-tab ${g === i ? 'on' : ''}`} onClick={() => setG(i)}>{name}</button>
          ))}
        </div>
        <div className="ep-table">
          <div className="ep-row head">
            <span>METHOD</span><span>PATH</span><span>DESCRIPTION</span><span>SCOPE</span>
          </div>
          {rows.map((r, i) => (
            <div key={i} className="ep-row">
              <span className={`verb ${r.vc}`}>{r.v}</span>
              <span className="path">{r.p}</span>
              <span className="desc" dangerouslySetInnerHTML={{ __html: r.d }} />
              <span className="scope">{r.s}</span>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', gap: 12, marginTop: 32, flexWrap: 'wrap' }}>
          <a href="/docs" className="btn btn-on-light"><span>See docs and contracts <Arrow /></span></a>
          <a href="/ai" className="btn btn-on-light"><span>See hosted MCP details <Arrow /></span></a>
        </div>
      </div>
    </section>
  );
}

function Scopes() {
  const scopes = [
    { n: '01', name: 'mcp:devices:read', desc: 'Inspect enrolled devices safely.' },
    { n: '02', name: 'mcp:devices:write', desc: 'Run approval-aware device mutations.' },
    { n: '03', name: 'mcp:private_apps:read', desc: 'Inspect protected-app state.' },
    { n: '04', name: 'mcp:private_apps:write', desc: 'Create or disable protected apps through approval-aware tools.' },
    { n: '05', name: 'mcp:private_network:read', desc: 'Read private-network diagnostics and health.' },
    { n: '06', name: 'mcp:secure_dns:read', desc: 'Inspect Secure DNS state and analytics.' },
    { n: '07', name: 'mcp:setup_tokens:write', desc: 'Create setup tokens and install commands safely.' },
    { n: '08', name: 'mcp:egress:write', desc: 'Mint bounded public-web task handles.' },
  ];
  return (
    <section className="scopes-section">
      <div className="dark-grid"></div>
      <div className="container">
        <div className="section-h">
          <span className="section-label">Auth &amp; scopes</span>
          <h2 style={{ color: 'var(--text-dark-primary)' }}>Eight hosted MCP scopes. Pick the smallest set.</h2>
          <p>Hosted MCP uses narrow tool-family scopes. The gateway checks every call, denies anything outside scope, and audits both allow and deny paths. Local <code>stdio</code> does not use these OAuth scopes; it follows the local agent and approval-token model instead.</p>
        </div>
        <div className="scopes-grid">
          {scopes.map(s => (
            <div key={s.n} className="scope-card">
              <div className="num">SCOPE {s.n}</div>
              <h4>{s.name.replace(/^mcp:/, '').split(':')[0]}</h4>
              <code>{s.name}</code>
              <p>{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function SDKs() {
  const sdks = [
    { mark: 'MCP', name: 'Hosted MCP endpoint', ver: 'Current Business surface', code: 'https://mcp.named.network/mcp' },
    { mark: 'STDIO', name: 'Local bridge', ver: 'Current workstation path', code: 'namedn mcp serve' },
    { mark: 'SPEC', name: 'Alpha contract in repo', ver: 'Current control-plane schema', code: 'packages/contracts/openapi/alpha.yaml' },
    { mark: 'CLI', name: 'Agent / CLI surface', ver: 'Current local tool entrypoint', code: 'namedn' },
  ];
  return (
    <section className="sdks">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">Current tooling</span>
          <h2>The real integration surfaces we have today.</h2>
          <p>What exists now is strong enough to build against: hosted MCP, the local <code>stdio</code> bridge, the in-repo alpha contract, and the <code>namedn</code> CLI or agent surface. Public SDK packaging can come later without us pretending it is already here.</p>
        </div>
        <div className="sdk-grid">
          {sdks.map(s => (
            <div key={s.mark} className="sdk">
              <div className="sdk-mark">{s.mark}</div>
              <h5>{s.name}</h5>
              <div className="ver">{s.ver}</div>
              <code>{s.code}</code>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Webhooks() {
  const events = [
    { e: 'mcp.tool_called', d: 'Hosted MCP tool call started and was recorded to audit.' },
    { e: 'mcp.tool_succeeded', d: 'Hosted MCP tool call completed successfully.' },
    { e: 'mcp.tool_approval_requested', d: 'A risky mutation returned an approval-required preview.' },
    { e: 'mcp.tool_approval_rejected', d: 'A previously requested approval token was rejected.' },
    { e: 'mcp.business_token_created', d: 'A new Business token was minted. Scope metadata is visible; raw secret is not.' },
    { e: 'mcp.business_token_revoked', d: 'A Business token was revoked from the workspace.' },
    { e: 'public_gateway.session_created', d: 'A bounded public-gateway session was created.' },
    { e: 'public_gateway.session_revoked', d: 'A bounded public-gateway session was revoked.' },
    { e: 'private_app.created', d: 'A new protected app was created through the control plane.' },
  ];
  return (
    <section className="webhooks">
      <div className="container">
        <div className="section-h">
          <span className="section-label on-light">Current event surface</span>
          <h2>Audit-backed events we can actually stand behind.</h2>
          <p>named.network already records first-class audit and session events for MCP, token lifecycle, protected apps, and bounded egress. A separate public signed webhook-delivery product is not the current claim, so this page should stay honest about that.</p>
        </div>
        <div className="wh-grid">
          <div className="wh-list">
            {events.map((e, i) => (
              <div key={i} className="wh-row">
                <div className="ev">{e.e}</div>
                <div className="desc">{e.d}</div>
              </div>
            ))}
          </div>
          <div>
            <div className="code-win">
              <div className="cw-head">
                <span>AUDIT EVENT SHAPE &mdash; representative</span>
                <span className="dots"><span></span><span></span><span></span></span>
              </div>
              <div className="cw-body">
                <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>
                  <span className="punct">{`{`}</span>{'\n'}
                  {'  '}<span className="key">"id"</span><span className="punct">:</span> <span className="str">"evt_4f29a1c"</span><span className="punct">,</span>{'\n'}
                  {'  '}<span className="key">"type"</span><span className="punct">:</span> <span className="str">"mcp.tool_approval_requested"</span><span className="punct">,</span>{'\n'}
                  {'  '}<span className="key">"data"</span><span className="punct">:</span> <span className="punct">{`{`}</span>{'\n'}
                  {'    '}<span className="key">"tool"</span><span className="punct">:</span> <span className="str">"setup_tokens.create"</span><span className="punct">,</span>{'\n'}
                  {'    '}<span className="key">"scope"</span><span className="punct">:</span> <span className="str">"mcp:setup_tokens:write"</span><span className="punct">,</span>{'\n'}
                  {'    '}<span className="key">"status"</span><span className="punct">:</span> <span className="str">"approval_required"</span>{'\n'}
                  {'  '}<span className="punct">{`}`}</span>{'\n'}
                  <span className="punct">{`}`}</span>
                </pre>
              </div>
            </div>
            <div style={{ fontFamily: 'var(--font-mono)', fontSize: 11, color: 'var(--text-light-muted)', marginTop: 14, letterSpacing: '0.04em' }}>
              Current product truth: audit-backed history and event categories are real; public outbound webhook delivery is a future developer-surface decision.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function FAQ() {
  const faqs = [
    { q: 'Is the API stable?', a: 'The current control-plane contract is real and versioned under <code>/v1</code>, but the honest public claim today is still “current alpha contract” rather than a long-promised public stability program. The stronger compatibility promise right now is on the hosted MCP Business surface we are actively validating.' },
    { q: 'How does MCP differ from your REST API?', a: 'They are related but not interchangeable. The hosted MCP surface is the current productized Business story for remote assistants, with narrow MCP scopes and approval-aware mutations. The underlying JSON control-plane API is the contract the dashboard already uses, and it is useful, but it should not be marketed as if it already has the same public auth and packaging polish as hosted MCP.' },
    { q: 'Do tokens have rate limits?', a: 'The repo already treats rate limits and abuse controls as real concerns, especially for higher-risk surfaces, but this page should not promise a polished public per-token developer rate-limit program that the product does not yet expose self-serve.' },
    { q: 'How do I rotate a leaked token?', a: 'For Business token workflows today, the honest claim is reveal-once secret handling plus revoke-and-recreate from the AI page or token-management surface. We should not promise a separate polished public rotate API here unless we ship it as a real product surface.' },
    { q: 'Can I run my own MCP server in front of you?', a: 'What we can honestly claim today is that the hosted endpoint and the local <code>namedn mcp serve</code> bridge are the supported product surfaces. More custom proxying or wrapper patterns may be possible for advanced teams, but they are not the public compatibility promise we should lead with.' },
    { q: 'Does the API live behind the VPN?', a: 'The control-plane API (<code>api.named.network</code>) is on the public internet, TLS, scoped tokens. The data-plane &mdash; your private apps &mdash; never is. You manage your private network with a public API; the network itself stays private. That\u2019s the whole point.' },
    { q: 'How do I test without a real workspace?', a: 'The truthful answer today is: use a real workspace, usually staging, and the current smoke or compatibility flows. We should not claim a polished public sandbox-token environment unless we actually ship one.' },
    { q: 'What about errors?', a: 'The current product already carries strong audit and error visibility, especially on hosted MCP and operator flows, but this page should not promise a fully standardized public developer error envelope beyond what the current contracts and product surfaces already expose.' },
  ];
  const [open, setOpen] = useState(0);
  return (
    <section className="section section-light">
      <div className="container-narrow">
        <div className="section-h">
          <span className="section-label on-light">FAQ</span>
          <h2>Eight common questions.</h2>
          <p>Anything not covered? Email us &mdash; we&rsquo;ll add it here.</p>
        </div>
        <div className="faq-list">
          {faqs.map((f, i) => (
            <div key={i} className={`faq-item ${open === i ? 'open' : ''}`}>
              <button className="faq-q" onClick={() => setOpen(open === i ? -1 : i)}>
                <span>{f.q}</span><span className="plus">+</span>
              </button>
              <div className="faq-a" dangerouslySetInnerHTML={{ __html: f.a }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function CTA() {
  return (
    <section className="section section-dark" style={{ padding: '128px 0' }}>
      <div className="dark-grid"></div>
      <div className="dark-glow"></div>
      <div className="container">
        <div className="cta-final">
          <span className="section-label">Ship something</span>
          <h2>One workspace.<br/><em>Hosted MCP first.</em></h2>
          <p>Business unlocks hosted MCP, scoped Business tokens, bounded egress, and the advanced control-plane surfaces that sit behind the named.network workspace.</p>
          <div className="ctas" style={{ marginTop: 36 }}>
            <a href="https://app.named.network/signup" className="btn btn-accent btn-lg"><span>Create a Business workspace <Arrow /></span></a>
            <a href="/ai" className="btn btn-on-dark btn-lg"><span>See AI &amp; Automation</span></a>
          </div>
        </div>
      </div>
    </section>
  );
}

function App() {
  return (
    <>
      <SiteNav />
      <Hero />
      <Protocols />
      <MCPSection />
      <Endpoints />
      <Scopes />
      <SDKs />
      <Webhooks />
      <FAQ />
      <CTA />
      <SiteFooter />
    </>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(<App />);

